export default __webpack_public_path__ + "static/media/icon-admin.24f2eadf.svg";